/* eslint-disable no-shadow */
const state = {
  redirectToDescription: false,
  redirectToSubscription: false,
  showLiveVideo: false,
  redirectToFollowTeacher: false,
  redirectToAddReview: false,
  checkoutFromCart: false,
  showCartToast: false
};

const getters = {
  getRedirectToDescription: state => state.redirectToDescription,
  getRedirectToSubscription: state => state.redirectToSubscription,
  getShowLiveVideo: state => state.showLiveVideo,
  getFollowTeacher: state => state.redirectToFollowTeacher,
  getAddReview: state => state.redirectToAddReview,
  isCheckout: state => state.checkoutFromCart,
  getShowCartToast: state => state.showCartToast
};

const mutations = {
  setRedirectToDescriptionMutation: (state, payload) => {
    state.redirectToDescription = payload;
  },
  setRedirectToSubscriptionMutation: (state, payload) => {
    state.redirectToSubscription = payload;
  },
  setShowLiveVideoMutation: (state, payload) => {
    state.showLiveVideo = payload;
  },
  setFollowTeacherMutation: (state, payload) => {
    state.redirectToFollowTeacher = payload;
  },
  setAddReviewMutation: (state, payload) => {
    state.redirectToAddReview = payload;
  },
  setIsCheckoutMutation: (state, payload) => {
    state.checkoutFromCart = payload;
  },
  setShowCartToastMutation: (state, payload) => {
    state.showCartToast = payload;
  }
};

const actions = {
  setRedirectToDescription: ({ commit }, payload) => {
    commit("setRedirectToDescriptionMutation", payload);
  },
  setRedirectToSubscription: ({ commit }, payload) => {
    commit("setRedirectToSubscriptionMutation", payload);
  },
  setShowLiveVideo: ({ commit }, payload) => {
    commit("setShowLiveVideoMutation", payload);
  },
  setFollowTeacher: ({ commit }, payload) => {
    commit("setFollowTeacherMutation", payload);
  },
  setAddReview: ({ commit }, payload) => {
    commit("setAddReviewMutation", payload);
  },
  setIsCheckout: ({ commit }, payload) => {
    commit("setIsCheckoutMutation", payload);
  },
  setShowCartToast: ({ commit }, payload) => {
    commit("setShowCartToastMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
